import {windowInfo} from './WindowInfo.js';
import {pubsub} from './Pubsub.js'

class ResizeEnd {
	#delta = 200;
	#rtime;
	#timeout = false;
	#ww = 0;
	#wh = 0;

	constructor() {
		this.#ww = windowInfo.size.w;
		this.#wh = windowInfo.size.h;
		$(window).on('resize', () => {
			this.#rtime = Date.now();
			if (!this.#timeout) {
				this.#timeout = true;
				setTimeout(this.#judge, this.#delta);
			}
		});
	}

	#judge = () => {
		if (Date.now() - this.#rtime < this.#delta) {
			setTimeout(this.#judge, this.#delta);
		} else {
			this.#timeout = false;

			if (this.#ww !== windowInfo.size.w || this.#wh !== windowInfo.size.h) {
				$(window).trigger('resizeEnd');
				pubsub.pub('resizeEnd')
			}

			if (this.#ww !== windowInfo.size.w) {
				$(window).trigger('resizeEnd:width');
				pubsub.pub('resizeEnd:width')
				this.#ww = windowInfo.size.w;
			}

			if (this.#wh !== windowInfo.size.h) {
				$(window).trigger('resizeEnd:height');
				pubsub.pub('resizeEnd:height')
				this.#wh = windowInfo.size.h;
			}
		}
	}
}

declare global {
	interface Window {
		resizeend: ResizeEnd
	}
}




/**
 windowのresizeが終わったときにイベントを発生させるやつ < br /> importするだけで使える

 @fires resizeEnd
 @example JS windowの幅or高さが変わったら発火するイベント
 ```js
 import '/assets/js/modules/ResizeEnd.js'
 $(window).on('resizeEnd', (e) => {
	console.log('aaaaaaa')
	})
	```

@fires resizeEnd:width
@example JS windowの幅が変わったら発火するイベント
```js
import '/assets/js/modules/ResizeEnd.js'
$(window).on('resizeEnd:width', (e) => {
	console.log('aaaaaaa')
	})
	```

@fires resizeEnd:height
@example JS windowの高さが変わったら発火するイベント
```js
import '/assets/js/modules/ResizeEnd.js'
$(window).on('resizeEnd:height', (e) => {
	console.log('aaaaaaa')
})
```
*/
export const resizeend = window.resizeend = new ResizeEnd();
